import Layout from "../../layouts/Layout";
import { Container, Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import React, { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";
import Services from "../../components/ProductPage/Services";
import ProductList from "../../components/ProductPage/ProductList";
import Cart from "../../components/ProductPage/Cart";
import Tyre from "../../components/ProductPage/elements/Tyre";
import RepairReview from "../ProductPage/elements/RepairReview";

import {
  getModel,
  getVariants,
  getWorkshopFilterMap,
  clearWorkshopFilterMap,
  getWorkshopsAddonByVariant,
  getCoordinates,
  getWorkshopFilterMapTwo,
  getWorkshopsJourneyVariant,
  getWorkshopsProductCategory,
  getCategory,
  fetchLevelupMembership,
  fetchDefaultWorkshop,
} from "../../redux/actions/apiActions";
import {
  fetchCarBrandModal,
  getCarBrandModal,
  setCarPopup,
  setCurrentCategory,
  setLayer,
  setLoader,
  setSelctedId,
  toggleChooseCar,
  toggleLocation,
  toggleLoginForm,
  toggleManageCar,
  toggleSearch,
  toggleSignupForm,
  toggleSosForm,
} from "../../redux/actions/globalAction";
import { getCartData } from "../../redux/actions/globalAction";
import { getService } from "../../redux/actions/globalAction";
import { getAddon } from "../../redux/actions/globalAction";
import useWindowDimensions from "../../components/WindowSize";
import { Faq, Google, OBA } from "../../components/Homepage";
import {
  AppliedCartOffers,
  applyRedeem,
  fetchCartAddedAddons,
  fetchCartAddedPackages,
  fetchCartJobItems,
  fetchCartProducts,
  fetchCartWorkshop,
  removePromotionsPromocode,
  setCartAddons,
  setCartJobItems,
  setCartJourney,
  setCartProducts,
  setCartStage,
  setCartWorkshop,
  setShowMobileIstand,
  showLoader,
} from "../../redux/actions/cartAction";
import { useRouter } from "next/router";
import { fetchCart, saveCartJobs } from "../../lib/cart";
import ConfirmCartChange from "../common/ConfirmCartChange";
import ServiceContent from "./service-content";
import {
  gtmProductEcommerceUrlParameters,
  gtmEcommerceAddToCart,
} from "../../lib/google-tag-manager";
import { gtm_ecommerce_viewItem_list } from "lib/GA4_tag";
import RepairFaq from "../ProductPage/elements/RepairFaq";
import AssureStrip from "../../components/Home/assure-strip";
import RepairAssureStrip from "./elements/RepairAssureStrip";
import AssureMobile from "components/Home/assure-mobile";
import axios from "axios";
import API from "api";
import { workshopSelection } from "actions/Cart";
import ChooseCarMobile from "components/common/ChooseCarMobile";
import { fetchBuy3Get1 } from "redux/actions/profileAction";

const Product = ({
  getWorkshopsProductCategory,
  getWorkshopsJourneyVariant,
  getAddon,
  getService,
  apiData,
  getModel,
  globalData,
  getCarBrandModal,
  getVariants,
  id,
  getWorkshopFilterMap,
  getWorkshopsAddonByVariant,
  getCartData,
  getWorkshopFilterMapTwo,
  getCategory,
  fetchCarBrandModal,
  variantId,
  cart,
  fetchLevelupMembership,
  type,
  fetchDefaultWorkshop,
  selectedWorkshop,
  setCartWorkshop,
  setCartStage,
  selectedCar,
  setLoader,
  setShowMobileIstand,
  loginData,
  setCartProducts,
  setCartJobItems,
  setCartAddons,
  setLayer,
  showLoader,
  removePromotionsPromocode,
  applyRedeem,
  toggleLocation,
  toggleLoginForm,
  toggleSosForm,
  toggleChooseCar,
  toggleSignupForm,
  toggleManageCar,
  toggleSearch,
  setSelctedId,
  setCurrentCategory,
  setCarPopup,
  AppliedCartOffers,
}) => {
  const [show, setShow] = useState(true);

  const [workData, setWorkData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [typeOne, setTypeOne] = useState(0);
  const [typeTwo, setTypeTwo] = useState(0);
  const { height, width } = useWindowDimensions();
  const router = useRouter();
  const [showWarning, setShowWarning] = useState(false);
  const [redirectURL, setRedirectURL] = useState(null);
  const [firstRender, setFirstRender] = useState(true);

  const [selected, setSelected] = useState(id);
  const [carPopupMobile, setCarPopupMobile] = useState(false);
  const [variants, setVariant] = useState([]);
  const [jobItems, setJobItems] = useState([]);

  let header = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  useEffect(async () => {
    const reload = localStorage.getItem("reload");
    const checkForPageRefresh = () => {
      const navigationEntries = performance.getEntriesByType("navigation");
      const isPageRefreshed =
        navigationEntries.length > 0 && navigationEntries[0].type === "reload";

      localStorage.setItem("reload", true);

      return isPageRefreshed;
    };

    checkForPageRefresh();

    if (
      localStorage.getItem("mobileCart") ||
      localStorage.getItem("showCart")
    ) {
      setShowMobileIstand(true);
      localStorage.removeItem("mobileCart");
      localStorage.removeItem("showCart");
    } else {
      setLayer(false);
    }
    if (
      JSON.parse(localStorage.getItem("cart-job-items") ?? JSON.stringify([]))
        .length ||
      JSON.parse(localStorage.getItem("cart-packages") ?? JSON.stringify([]))
        .length
    ) {
      if (
        firstRender &&
        router.query &&
        router.query.slug &&
        router.query.slug.length &&
        router.query.slug[1] &&
        !localStorage.getItem("isHeader") &&
        !localStorage.getItem("isCartClear") &&
        !localStorage.getItem("Backbutton")
      ) {
        if (reload == 0) {
          setShowWarning(true);
        }
        setRedirectURL(router.asPath);
        setFirstRender(false);
        localStorage.removeItem("isCartClear");
        localStorage.removeItem("Backbutton");
      }
      if (
        firstRender &&
        router.query &&
        router.query.slug &&
        router.query.slug.length &&
        router.query.slug[1] &&
        router.query.slug[2] &&
        router.query.cart == 1 &&
        isMobile
      ) {
        setShowMobileIstand(true);
        setCartStage(4);
        localStorage.setItem("mobileCart", true);
      }
    } else {
      setFirstRender(false);
      localStorage.removeItem("isCartClear");
    }
    if (localStorage.getItem("BackButton")) setCartStage(4);
    localStorage.removeItem("isHeader");
    localStorage.removeItem("isCartClear");
    if (!sessionStorage.getItem("isWorkshopCollection")) getCategory();
    fetchCarBrandModal();
    fetchLevelupMembership();
    fetchDefaultWorkshop();
    if (selectedWorkshop) {
      setCartWorkshop(selectedWorkshop);
      setCartStage(4);
    }
    if (selectedCar) {
      let carData = {};
      if (selectedCar.CarCompany) {
        carData.brand = selectedCar.CarCompany.Name;
        carData.brandUrl = selectedCar.CarCompany.ImgUrl;
        carData.brandId = selectedCar.CarCompany.ID;
        const data = JSON.parse(
          localStorage.getItem("car_data") || JSON.stringify("")
        );
        if (selectedCar.CarModel) {
          getCarBrandModal(
            carData.brand,
            selectedCar.CarModel.Name,
            carData.brandUrl,
            selectedCar.CarModel.ImgUrl,
            carData.brandId,
            selectedCar.CarModel.ID,
            data && data.slug ? data.slug : null
          );
        } else {
          getModel(carData.brandId);
          setCarPopup("model");
          getCarBrandModal(
            carData.brand,
            null,
            carData.brandUrl,
            null,
            carData.brandId,
            null
          );
        }
      }
    }

    return () => {
      localStorage.removeItem("mobileCart");
      // This will run when the component is unmounted or when dependencies change
      // Add any cleanup logic here
    };
  }, []);

  const fetchOilChangeData = async () => {
    const data = await fetchBuy3Get1();
    if (data && data.Data && data.Data.length) {
      const oilCount =
        data.Data.length > 3 ? data.Data.length % 4 : data.Data.length;
      if (oilCount === 3) {
        localStorage.setItem("freeOilData", JSON.stringify(data.Data[0]));
      } else {
        localStorage.removeItem("freeOilData");
      }
    }
  };

  useEffect(() => {
    localStorage.setItem("reload", 1);
    fetchOilChangeData();
    return () => {
      localStorage.setItem("reload", 0);
    };
  }, []);

  useEffect(async () => {
    if (selectedWorkshop) {
      setCartStage(null);
    }
    let oldCart = await fetchCart();
    const data = JSON.parse(
      localStorage.getItem("car_data") || JSON.stringify("")
    );

    if (oldCart?.Data) {
      if (oldCart.Data.workshop) setCartWorkshop(oldCart.Data.workshop);
      setCartProducts(oldCart.Data.product);
      setCartJobItems(oldCart.Data.jobs);
      setCartAddons(oldCart.Data.addons);
      if (oldCart.Data?.CarDetails && !data) {
        getCarBrandModal(
          oldCart.Data?.CarDetails?.CarCompanyName,
          oldCart.Data?.CarDetails?.CarModelName,
          oldCart.Data?.CarDetails?.CarCompany.ImgUrl,
          oldCart.Data?.CarDetails?.CarModel.ImgUrl,
          oldCart.Data?.CarDetails?.CarCompany.ID,
          oldCart.Data?.CarDetails?.CarModel.ID,
          data && data.slug ? data.slug : null
        );
      }
    } else {
      if (!sessionStorage.getItem("isWorkshopCollection"))
        setCartWorkshop(null);
    }
  }, [loginData]);

  useEffect(() => {
    localStorage.setItem("trigger-action", true);
    removePromotionsPromocode();
    applyRedeem(0);
    const startOver = localStorage.getItem("startOver");
    if (
      (JSON.parse(localStorage.getItem("cart-job-items") ?? JSON.stringify([]))
        ?.length ||
        JSON.parse(localStorage.getItem("cart-packages") ?? JSON.stringify([]))
          ?.length) &&
      !startOver
    ) {
      localStorage.removeItem("isCartClear");
      if (isMobile) {
        return;
      } else {
        const startOver = localStorage.getItem("startOver");
        if (startOver) {
          setLayer(false);
          localStorage.removeItem("startOver");
        } else {
          setLayer(true);
        }
      }
    } else {
      setLayer(false);
    }
    return () => {
      toggleChooseCar(false);
      setCurrentCategory([]);
      setCartJourney(null);
      localStorage.removeItem("startOver");
      const workshopSelected = localStorage.getItem("workshop-selected");
      localStorage.removeItem("isQuoterequest");
      if (
        !cart.workshop &&
        (!workshopSelected ||
          workshopSelected === null ||
          workshopSelected === "null" ||
          workshopSelected === "")
      ) {
        setCartStage(null);
        setCartProducts([]);
        setCartJobItems([]);
        if (!sessionStorage.getItem("isWorkshopCollection"))
          setCartWorkshop(null);
      }
    };
  }, []);

  useEffect(() => {
    localStorage.removeItem("address-saved");
    const cartEmpty = localStorage.getItem("cartEmpty");
    if (cartEmpty) {
      localStorage.removeItem("cartEmpty");
      setCartStage(null);
      setCartProducts([]);
      setCartJobItems([]);
      if (!sessionStorage.getItem("isWorkshopCollection"))
        setCartWorkshop(null);
      setLayer(false);
      localStorage.removeItem("cart-packages");
      localStorage.removeItem("isSmartSelection");
      localStorage.removeItem("cart-job-items");
    }
  }, []);

  useEffect(() => {
    toggleLocation(false);
    toggleLoginForm(false);
    toggleSosForm(false);
    toggleSignupForm(false);
    toggleSearch(false);
  }, []);
  useEffect(() => {
    if (
      apiData &&
      apiData?.variants &&
      apiData?.variants?.length > 0 &&
      localStorage.getItem("selected-service") !== "service-contract"
    ) {
      const areArraysEqual =
        variants.length &&
        variants[0].JourneyCategoryId == apiData?.variants[0].JourneyCategoryId;
      if (!areArraysEqual) {
        const items = apiData.variants.map((items, index) => ({
          item_id: items.Id,
          item_name: items.Name,
          item_category: items.IslandType,
          price: items.Cost,
          index: index,
          quantity: 1,
        }));
        gtm_ecommerce_viewItem_list({
          item_list_id: apiData?.variants[0].JourneyCategoryId,
          items: items,
        });
      }
      setVariant(apiData?.variants);
    }
  }, [apiData.variants]);

  useEffect(() => {
    if (cart.stage == null) {
      if (cart.workshop && cart.addedPackages?.length > 0) {
        setCartStage(4);
      }
    }
    if (cart.workshop) {
      getVariants(selected, globalData?.carData?.modelId, cart.workshop?.Id);
    }
    const cart_offers = JSON.parse(
      sessionStorage.getItem("cart-offers") || JSON.stringify("")
    );
    if (cart_offers) {
      AppliedCartOffers(cart_offers);
    }
  }, [cart.workshop, cart.addedPackages]);

  useEffect(() => {
    getVariants(selected, globalData?.carData?.modelId, cart.workshop?.Id);
    if (
      router.pathname === `/services/[...slug]` &&
      globalData?.carData &&
      !cart.workshop?.Id
    ) {
      const cardata = globalData?.carData?.slug;
      // const CarData = JSON.parse(
      // localStorage.getItem("car_data") )
      const carName =
        `${globalData?.carData.brand} ${globalData?.carData.modal}`
          .trim()
          .split(" ")
          .join("-")
          .toLowerCase()
          .split(".")
          .join("");

      router.push(
        `/services/${
          globalData.locationData?.data.EmirateAreaSlug || "dubai"
        }/${router.query.slug[1]}/${carName}`
      );
      console.log(router);
    }
  }, [globalData?.carData]);

  const [scroll, setScroll] = useState(0);
  const [hidePoint, setHidePoint] = useState(0);

  useEffect(() => {
    setLoader(false);
    let footer = document.getElementsByTagName("footer")[0];
    setHidePoint(
      window.document.body.scrollHeight -
        window.innerHeight * 1 -
        footer.scrollHeight
    );
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [
    typeof window !== "undefined" ? window.document.body.scrollHeight : null,
  ]);

  useEffect(() => {
    if (
      router.query?.slug?.length &&
      (router.query?.slug[2] == "car" ||
        router.query?.slug[2] == "undefined") &&
      !localStorage.getItem("car_data")
    ) {
      if (!isMobile) {
        setCarPopup("brand");
      } else {
        const data = localStorage.getItem("pro_click");
        if (data) {
          return;
        }
        setCarPopupMobile("brand");
      }
    }
    return () => {
      setCarPopup(null);
      setCarPopupMobile(null);
      localStorage.removeItem("hide_level_up");
    };
  }, [router]);

  useEffect(async () => {
    const hasURlItems = JSON.parse(
      localStorage.getItem("url_data") || JSON.stringify("{}")
    );
    const carData = JSON.parse(
      localStorage.getItem("car_data") || JSON.stringify("")
    );
    let oldCart = await fetchCart();
    if (
      oldCart?.Data &&
      oldCart?.Data?.product?.length &&
      oldCart.Data?.jobs?.length
    ) {
      if (
        oldCart.Data?.product?.Id == hasURlItems.variantId &&
        oldCart.Data?.workshop?.Id == hasURlItems.workshopId
      ) {
        return;
      }
      return;
    }

    if (
      hasURlItems &&
      hasURlItems.variantId &&
      (carData || localStorage.getItem("repeat-order-car"))
    ) {
      showLoader(true);
      selectWorkshop(
        hasURlItems.brandId,
        hasURlItems.variantId,
        hasURlItems.workshopId,
        localStorage.getItem("repeat-order-car")
      );
      gtmProductEcommerceUrlParameters();
    }
  }, [globalData.carData]);

  const selectWorkshop = async (
    brandId = null,
    variantId,
    workshopId,
    repeatCar = null
  ) => {
    if (isMobile) {
      setShowMobileIstand(true);
    } else {
      setLayer(true);
    }
    const car = JSON.parse(
      localStorage.getItem("car_data") || JSON.stringify("")
    );
    const res = await workshopSelection(
      workshopId,
      variantId,
      car.modelId,
      brandId
    );
    if (res.err) {
      showLoader(false);
      return;
    }
    if (res && res.Data && res.Data?.length) {
      await saveCartJobs(
        cart,
        apiData,
        {
          ...globalData,
          carData: {
            ...globalData?.carData,
            modelId: repeatCar
              ? JSON.parse(repeatCar)?.CarModel.Id
              : globalData?.carData?.modelId,
          },
        },
        [{ ...res.Data[0], BrandId: brandId }]
      );
      let oldCart = await fetchCart();
      const data = JSON.parse(
        localStorage.getItem("car_data") || JSON.stringify("")
      );
      if (oldCart?.Data) {
        if (oldCart.Data.workshop) setCartWorkshop(oldCart.Data.workshop);
        setCartProducts(oldCart.Data.product);
        setCartJobItems(oldCart.Data.jobs);
        setCartAddons(oldCart.Data.addons);
        if (
          oldCart.Data?.CarDetails &&
          !(repeatCar && localStorage.getItem("url_data"))
        ) {
          getCarBrandModal(
            oldCart.Data?.CarDetails?.CarCompanyName,
            oldCart.Data?.CarDetails?.CarModelName,
            oldCart.Data?.CarDetails?.CarCompany.ImgUrl,
            oldCart.Data?.CarDetails?.CarModel.ImgUrl,
            oldCart.Data?.CarDetails?.CarCompany.ID,
            oldCart.Data?.CarDetails?.CarModel.ID,
            null
          );
        }
      }
      localStorage.setItem("hide_level_up", true);
      localStorage.removeItem("url_data");
      if (repeatCar) {
        const carDetails = JSON.parse(repeatCar);
        getCarBrandModal(
          carDetails?.CarCompany?.CompanyName,
          carDetails?.CarModel.Name,
          carDetails?.CarCompany.ImgUrl,
          carDetails?.CarModel.ImgUrl,
          carDetails?.CarCompany.Id,
          carDetails?.CarModel.Id,
          data && data.slug ? data.slug : null
        );
        localStorage.removeItem("repeat-order-car");
      }
      setCartStage(4);
      showLoader(false);
    } else {
      localStorage.removeItem("url_data");
      setLayer(false);
      setCartStage(null);
      showLoader(false);
    }
    localStorage.setItem("product-id", JSON.stringify(variantId));
    localStorage.setItem("brand-id", brandId);
  };

  const handleScroll = () => {
    setScroll(window.scrollY);
  };

  return (
    <Layout locationOn={true} hideScrollToTop>
      <ChooseCarMobile show={carPopupMobile} setShow={setCarPopupMobile} />
      {!isMobile && globalData && globalData.layer && cart.stage != 2 ? (
        <div style={{ zIndex: 8 }} className="bg-layer">
          <p
            onClick={() => {
              if (!(cart && cart.workshop)) {
                setCartStage(null);
                setCartProducts([]);
                setCartJobItems([]);
              }
              setLayer(false);
            }}
            className="layer"
          >
            X
          </p>
        </div>
      ) : null}

      <Container
        fluid
        style={{ paddingRight: "10px", paddingLeft: "10px", overflowX: "clip" }}
      >
        <Row>
          <Col lg={7} md={7} sm={12}>
            <Services
              setSelected={setSelctedId}
              selected={globalData.selected_id}
              categorySliderData={apiData}
              getVariants={getVariants}
              id={globalData.selected_id ? globalData.selected_id : id}
            />
            <ProductList
              cart={cart}
              setTypeOne={setTypeOne}
              setTypeTwo={setTypeTwo}
              id={globalData.selected_id}
              setWorkData={setWorkData}
              setServiceData={setServiceData}
              serviceData={serviceData}
              workData={workData}
              show={show}
              setShow={setShow}
              variants={apiData.variants}
              getModel={getModel}
              apiData={apiData}
              globalData={globalData}
              getCarBrandModal={getCarBrandModal}
              getWorkshopFilterMap={getWorkshopFilterMap}
              variantId={variantId}
              type={type}
            />
            {!isMobile ? <RepairAssureStrip /> : <AssureMobile />}
            <RepairReview />
            <RepairFaq setLoader={setLoader} />
            <ServiceContent />
            {/* <div className="d-flex justify-content-center">
              {cart.stage != null && (
                <button
                  className="cart-mobile-btn"
                  onClick={() => setShowMobileIstand(true)}
                >
                  View Cart
                </button>
              )}
            </div> */}
          </Col>
          {cart.showMobileIsland && (
            <div className="island-box">
              {typeOne == 0 ? (
                <>
                  <Cart
                    id={id}
                    getWorkshopsProductCategory={getWorkshopsProductCategory}
                    getWorkshopsJourneyVariant={getWorkshopsJourneyVariant}
                    getWorkshopFilterMapTwo={getWorkshopFilterMapTwo}
                    getService={getService}
                    getAddon={getAddon}
                    setWorkData={setWorkData}
                    setServiceData={setServiceData}
                    serviceData={serviceData}
                    workData={workData}
                    show={show}
                    setShow={setShow}
                    getModel={getModel}
                    apiData={apiData}
                    globalData={globalData}
                    getCarBrandModal={getCarBrandModal}
                    getWorkshopFilterMap={getWorkshopFilterMap}
                    getWorkshopsAddonByVariant={getWorkshopsAddonByVariant}
                  />
                </>
              ) : (
                <>
                  {!isMobile && width > 800 && (
                    <Tyre
                      typeTwo={typeTwo}
                      getModel={getModel}
                      apiData={apiData}
                      globalData={globalData}
                      getCarBrandModal={getCarBrandModal}
                    />
                  )}
                </>
              )}
            </div>
          )}
          {typeOne == 0 ? (
            <Col
              lg={5}
              md={5}
              className="scroll-vertical"
              style={
                globalData && globalData?.layer
                  ? {
                      zIndex: 9,
                      opacity: hidePoint < scroll ? "0" : "1",
                      transition: "all .2s",
                      visibility: hidePoint < scroll ? "hidden" : "visible",
                    }
                  : {
                      opacity: hidePoint < scroll ? "0" : "1",
                      transition: "all .2s",
                      visibility: hidePoint < scroll ? "hidden" : "visible",
                    }
              }
            >
              {!isMobile && width > 800 && (
                <Cart
                  id={id}
                  getWorkshopsProductCategory={getWorkshopsProductCategory}
                  getWorkshopsJourneyVariant={getWorkshopsJourneyVariant}
                  getWorkshopFilterMapTwo={getWorkshopFilterMapTwo}
                  getService={getService}
                  getAddon={getAddon}
                  setWorkData={setWorkData}
                  setServiceData={setServiceData}
                  serviceData={serviceData}
                  workData={workData}
                  show={show}
                  setShow={setShow}
                  getCartData={getCartData}
                  getModel={getModel}
                  apiData={apiData}
                  globalData={globalData}
                  getCarBrandModal={getCarBrandModal}
                  getWorkshopFilterMap={getWorkshopFilterMap}
                  getWorkshopsAddonByVariant={getWorkshopsAddonByVariant}
                />
              )}
            </Col>
          ) : (
            <Col lg={5} md={5} className="scroll-vertical">
              {!isMobile && width > 800 && (
                <Tyre
                  typeTwo={typeTwo}
                  getModel={getModel}
                  apiData={apiData}
                  globalData={globalData}
                  getCarBrandModal={getCarBrandModal}
                />
              )}
            </Col>
          )}
        </Row>
      </Container>
      <ConfirmCartChange
        show={showWarning}
        onHide={() => setShowWarning(false)}
        redirectURL={redirectURL}
        cartPage={true}
      />
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    cart: state.cart,
    loginData: state.loginData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getModel: (id) => {
      dispatch(getModel(id));
    },
    setLayer: (status) => {
      dispatch(setLayer(status));
    },
    getVariants: (id, mId, WId) => {
      dispatch(getVariants(id, mId, WId));
    },
    getCartData: (data) => {
      dispatch(getCartData(data));
    },
    getService: (data) => {
      dispatch(getService(data));
    },
    getAddon: (data) => {
      dispatch(getAddon(data));
    },
    getWorkshopsAddonByVariant: (id, vId) => {
      dispatch(getWorkshopsAddonByVariant(id, vId));
    },
    getCoordinates: (lat, lang, size) => {
      dispatch(getCoordinates(lat, lang, size));
    },
    clearWorkshopFilterMap: () => {
      dispatch(clearWorkshopFilterMap());
    },
    getWorkshopFilterMap: (size, page, lat, lang, vId, mId, filter) => {
      dispatch(getWorkshopFilterMap(size, page, lat, lang, vId, mId, filter));
    },
    getWorkshopFilterMapTwo: (size, page, lat, lang, vId, mId, filter) => {
      dispatch(
        getWorkshopFilterMapTwo(size, page, lat, lang, vId, mId, filter)
      );
    },
    getWorkshopsJourneyVariant: (id, cId, mId) => {
      dispatch(getWorkshopsJourneyVariant(id, cId, mId));
    },
    getWorkshopsProductCategory: (id, mId) => {
      dispatch(getWorkshopsProductCategory(id, mId));
    },
    getCarBrandModal: (
      brand,
      modal,
      logoBrand,
      logoModal,
      brandId,
      modelId,
      slug = null,
      setNull = false
    ) => {
      dispatch(
        getCarBrandModal(
          brand,
          modal,
          logoBrand,
          logoModal,
          brandId,
          modelId,
          slug,
          setNull
        )
      );
    },
    getCategory: () => {
      dispatch(getCategory());
    },
    fetchCarBrandModal: () => {
      dispatch(fetchCarBrandModal());
    },
    fetchLevelupMembership: () => {
      dispatch(fetchLevelupMembership());
    },
    fetchDefaultWorkshop: () => {
      dispatch(fetchDefaultWorkshop());
    },
    setCartWorkshop: (data) => {
      dispatch(setCartWorkshop(data));
    },
    setCartStage: (stage) => {
      dispatch(setCartStage(stage));
    },
    setLoader: (flag) => {
      dispatch(setLoader(flag));
    },
    setShowMobileIstand: (flag) => {
      dispatch(setShowMobileIstand(flag));
    },
    setCartProducts: (data) => {
      dispatch(setCartProducts(data));
    },
    setCartJobItems: (data) => {
      dispatch(setCartJobItems(data));
    },
    setCartAddons: (data) => {
      dispatch(setCartAddons(data));
    },

    //over layout

    toggleSearch: (stage) => {
      dispatch(toggleSearch(stage));
    },
    toggleSosForm: (stage) => {
      dispatch(toggleSosForm(stage));
    },
    toggleChooseCar: (stage) => {
      dispatch(toggleChooseCar(stage));
    },
    toggleSignupForm: (stage) => {
      dispatch(toggleSignupForm(stage));
    },
    toggleLoginForm: (stage) => {
      dispatch(toggleLoginForm(stage));
    },
    toggleLocation: (stage) => {
      dispatch(toggleLocation(stage));
    },
    toggleManageCar: (stage) => {
      dispatch(toggleManageCar(stage));
    },
    setCarPopup: (flag) => {
      dispatch(setCarPopup(flag));
    },

    // Fetch from Cart

    fetchCartWorkshop: () => {
      dispatch(fetchCartWorkshop());
    },
    fetchCartProducts: () => {
      dispatch(fetchCartProducts());
    },
    fetchCartJobItems: () => {
      dispatch(fetchCartJobItems());
    },
    fetchCartAddedAddons: () => {
      dispatch(fetchCartAddedAddons());
    },
    fetchCartAddedPackages: () => {
      dispatch(fetchCartAddedPackages());
    },
    setCartJourney: (stage) => {
      dispatch(setCartJourney(stage));
    },
    showLoader: (stage) => {
      dispatch(showLoader(stage));
    },
    removePromotionsPromocode: () => {
      dispatch(removePromotionsPromocode());
    },
    applyRedeem: (data) => {
      dispatch(applyRedeem(data));
    },
    setSelctedId: (data) => {
      dispatch(setSelctedId(data));
    },
    setCurrentCategory: (data) => {
      dispatch(setCurrentCategory(data));
    },
    AppliedCartOffers: (data) => {
      dispatch(AppliedCartOffers(data));
    },
  };
};

// Product.getInitialProps = async ({ query }) => {
//   const {id} = query
//   return {id}
// };

export default connect(mapStateToProps, mapDispatchToProps)(Product);
